import { createSupportingModule, DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

enum SECTION_ENUM {
  AUTOS = '自動車',
  CAREERS = 'キャリア',
  ENERGY = 'エネルギー',
  HEALTHCARE = 'ヘルスケア'
}
const { AUTOS, BUSINESS, CAREERS, EARNINGS, ENERGY, HEALTHCARE, JOURNAL_REPORTS } = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { terms: { key: 'SectionType', value: [AUTOS, BUSINESS, EARNINGS, ENERGY, HEALTHCARE, JOURNAL_REPORTS] } }
    ]
  },
  ...DEFAULT_SORT
};

const AUTOS_QUERY = createSupportingModule([AUTOS]);
const CAREERS_QUERY = createSupportingModule([CAREERS]);
const ENERGY_QUERY = createSupportingModule([ENERGY]);
const HEALTHCARE_QUERY = createSupportingModule([HEALTHCARE]);

export { SECTION_ENUM, baseQuery as MAIN, AUTOS_QUERY, CAREERS_QUERY, ENERGY_QUERY, HEALTHCARE_QUERY };
